import { Redirect, Route } from 'react-router-dom';
import { PATH } from './constant';
import { LOCAL_STORAGE_KEY } from 'utils/constant';
import { useAuth } from 'contexts/AuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { UserQuizStatus } from 'containers/quiz_manager';
import { globalActions } from 'redux/global/global.slice';
import { UserType } from '__generated__/globalTypes';
import LoadingDataSpinner from 'component/loading_spinner/loading_data_spinner';
import { useEffect } from 'react';

export default function PrivateRouteAnonymous({ component: Component, ...rest }) {
    const { currentUser, socialLoginCallback } = useAuth();
    const user = useSelector((state: RootState) => state.userDetail.me);
    const hasLocalUserId = !!localStorage.getItem(LOCAL_STORAGE_KEY.LOCAL_USER_KEY);
    const from = JSON.parse(sessionStorage.getItem('from') || '{}');
    const pendingQuizzes = useSelector((state: RootState) => state.userDetail.pendingQuizzes);
    const isPendingQuizzes =
        pendingQuizzes?.hasOwnProperty('getPendingQuizzes') &&
        pendingQuizzes?.getPendingQuizzes?.quizConfigs?.filter((item) => item.status === UserQuizStatus.pending)
            ?.length;

    const dispatch = useDispatch();
    const spinnerLoading = useSelector((state: RootState) => state.global.spinnerLoading);

    const checkStoredLink = (PrefferedComponent) => {
        if (from?.from?.pathname) {
            sessionStorage.removeItem('from');
            setTimeout(() => {
                dispatch(globalActions.setSpinnerLoading(spinnerLoading.filter((item) => item !== 'loadingHome')));
            }, 2000);
            return (
                <Redirect
                    to={{
                        pathname: from?.from?.pathname,
                        search: from?.from?.search,
                    }}
                />
            );
        } else {
            return <PrefferedComponent />;
        }
    };
    useEffect(() => {
        if (currentUser && !user) {
            socialLoginCallback(currentUser);
        }
    }, [currentUser, socialLoginCallback, user]);

    return (
        <Route
            {...rest}
            render={(props) => {
                let { location } = props;
                if (!currentUser) {
                    if (hasLocalUserId) return <Component {...props} />;
                    return (
                        <Redirect
                            to={{
                                pathname: PATH.SIGNUP_ANONYMOUS_CUSTOMER,
                                state: { from: location },
                            }}
                        />
                    );
                }
                if (!user) return <LoadingDataSpinner />;
                if (user.userType !== UserType.customer)
                    <Redirect
                        to={{
                            pathname: '/home',
                            state: { from: location },
                        }}
                    />;
                if (isPendingQuizzes === 0 || location.pathname === PATH.QUIZ_MANAGER)
                    return checkStoredLink(Component);
                return (
                    <Redirect
                        to={{
                            pathname: '/home',
                            state: { from: location },
                        }}
                    />
                );
            }}
        />
    );
}
